import React from 'react';
import { CardBody } from 'reactstrap';
import ServiceClassificationTable from './components/ServiceClassificationTable';
import DefaultModal from 'components/Modal/DefaultModal';

const ServiceClassification = ({
  isModalOpen,
  onModalToggle,
  matrixSLAId,
  ...props
}) => {
  return (
    <>
      <DefaultModal
        show={isModalOpen}
        onModalToggle={onModalToggle}
        title="Classificações de Serviço"
        showCloseButton={false}
        modalContainerClasses="modal-xl"
        {...props}
      >
        <CardBody>
          <ServiceClassificationTable matrixSLAId={matrixSLAId} />
        </CardBody>
      </DefaultModal>
    </>
  );
};

export default ServiceClassification;
